import {Outlet, Navigate} from "react-router-dom";

import { getAuth } from "./common";

const ProtectedRoute = ()=>{
   const token = getAuth(); 
   return token ? <Outlet /> : <Navigate to={'/'} />
}

export default ProtectedRoute;